import type { MyBetSgmEvent, SgmResultType } from '@ps/web-sports-api-types';
import React from 'react';

import BetEventStatus from '../BetEventStatus/BetEventStatus';
import EventLink from '../Leg/components/EventLink/EventLink';
import EventTypeIcon from '../Leg/components/EventTypeIcon/EventTypeIcon';

import styles from './SgmEventDetails.scss';

interface Props {
  sgmEvent: MyBetSgmEvent;
  isSettled?: boolean;
  sgmResult?: SgmResultType;
  isBetBuilderPlus?: boolean;
}

const SgmEventDetails: React.FC<Props> = ({ sgmEvent, isSettled, sgmResult, isBetBuilderPlus }) => (
  <div className={styles.wrapper}>
    <EventTypeIcon
      result={isBetBuilderPlus ? undefined : sgmResult}
      eventTypeId={sgmEvent.eventTypeId}
      inPlay={sgmEvent.inPlay}
    />

    <div className={styles.eventInfoWrapper}>
      <EventLink isSgm part={sgmEvent.parts[0]} isSettled={isSettled} />

      <BetEventStatus part={sgmEvent.parts[0]} isSettled={isSettled} />
    </div>
  </div>
);

export default SgmEventDetails;
